import { Link } from 'react-router-dom';

const links = [
  { title: 'Обучение отдела продаж', desc: 'Развитие навыков продаж и управление отделом продаж.', to: '/enciklopediya-korporativnogo-obucheniya/obuchenie-otdela-prodazh' },
  { title: 'Тренинг по переговорам', desc: 'Универсальные и коммерческие переговоры для бизнеса.', to: '/prodazhi-i-peregovory/trening-po-peregovoram' },
  { title: 'Развитие Soft Skills', desc: 'Коммуникация, эмоциональный интеллект и гибкие навыки.', to: '/enciklopediya-korporativnogo-obucheniya/razvitie-soft-skills' },
  { title: 'Оценка эффективности обучения', desc: 'Как понять, что обучение принесло результат бизнесу.', to: '/enciklopediya-korporativnogo-obucheniya/ocenka-effektivnosti-obucheniya' },
  { title: 'Разработка программ обучения', desc: 'Проектирование корпоративных программ под задачи компании.', to: '/enciklopediya-korporativnogo-obucheniya/razrabotka-programm-obucheniya' },
];

export default function RelatedClusters() {
  return (
    <section className="py-16 md:py-24 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6">
        <h2 className="text-2xl md:text-4xl font-bold text-gray-900 text-center mb-3">
          Смежные направления обучения
        </h2>
        <p className="text-base md:text-lg text-gray-600 text-center mb-12 max-w-3xl mx-auto leading-relaxed">
          Развитие управленческих компетенций пересекается с другими направлениями корпоративного обучения — от продаж до оценки эффективности
        </p>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4 max-w-5xl mx-auto">
          {links.map((l) => (
            <Link
              key={l.to}
              to={l.to}
              className="bg-white rounded-xl border border-gray-200 p-5 hover:border-teal-300 transition-colors group cursor-pointer"
            >
              <h3 className="font-bold text-gray-900 text-sm mb-2 group-hover:text-teal-600 transition-colors">{l.title}</h3>
              <p className="text-gray-600 text-xs leading-relaxed mb-3">{l.desc}</p>
              <span className="inline-flex items-center gap-1 text-xs font-semibold text-teal-600">
                Подробнее
                <i className="ri-arrow-right-line"></i>
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}